import { render, staticRenderFns } from "./Order-edit.vue?vue&type=template&id=2b2137ce"
import script from "./Order-edit.vue?vue&type=script&lang=js"
export * from "./Order-edit.vue?vue&type=script&lang=js"
import style0 from "./Order-edit.vue?vue&type=style&index=0&id=2b2137ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports